<template>
  <navbar :checkLicense="false">
    <template #morePopover>
      <more-popover class="navbar-item-icon primary-color-hover" />
      <cloud-account-assistant-shortcut v-if="showCloudaccountSetupAssistant" />
    </template>
    <template #userPopover>
      <user-popover class="navbar-item" />
    </template>
  </navbar>
</template>

<script>
// import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import UserPopover from '../../sections/UserPopover'
import MorePopover from './MorePopover'
import Navbar from '@/sections/Navbar'
import CloudAccountAssistantShortcut from '@scope/views/common/components/CloudAccountAssistantShortcut'

export default {
  name: 'scopeNavbar',
  components: {
    Navbar,
    UserPopover,
    MorePopover,
    CloudAccountAssistantShortcut,
  },
  data () {
    return {
      cloudsupplierInfos: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'scope', 'isAdminMode', 'isDomainMode']),
    ...mapState('app', {
      customer: state => state.customer,
      user_guide: state => state.user_guide,
    }),
    showCloudaccountSetupAssistant () {
      if (this.isAdminMode || this.isDomainMode) {
        return this.user_guide.show_assistant_shortcut
      }
      return false
    },
  },
  async created () {
    await this.$store.dispatch('app/fetchCities')
  },
  methods: {
    toApprove () {
      if (this.scope === 'project') this.reLogin(this.userInfo.projectId, 'domain', '/approve')
      else if (this.$route.path !== '/approve') this.$router.push('/approve')
    },
    toCloudsupplier () {
      if (this.scope === 'project') this.reLogin(this.userInfo.projectId, 'domain', '/cloudsupplier')
      else if (this.$route.path !== '/cloudsupplier') this.$router.push('/cloudsupplier')
    },
    toCloudaccount () {
      if (this.scope === 'project') this.reLogin(this.userInfo.projectId, 'domain', '/cloudaccount/create')
      else if (this.$route.path !== '/cloudaccount/create') this.$router.push('/cloudaccount/create')
    },
    async reLogin (projectId, scope, target) {
      this.reLogging = true
      try {
        await this.$store.dispatch('auth/reLogin', projectId)
        await this.$store.commit('auth/SET_SCOPE', scope)
        await this.$store.dispatch('auth/getInfo')
        await this.$store.dispatch('auth/getPermission', scope)
        await this.$store.dispatch('auth/getScopeResource')
        if (this.$appConfig.isPrivate) {
          const resolveIndexRoute = this.$router.resolve('/')
          const currentRoute = this.$route
          if (target) {
            this.$router.push(target)
          } else {
            // 如果在首页则刷新
            if (resolveIndexRoute.route.path === currentRoute.path) {
              window.location.reload()
            } else {
              this.$router.push('/')
            }
          }
        }
      } catch (error) {
        throw error
      } finally {
        this.reLogging = false
      }
    },
    showCertTips () {
      this.$store.dispatch('common/updateObject', {
        name: 'topAlert',
        data: {
          enterpriseCertification: {
            messageOptions: [
              this.$t('scope.text_256'),
              ['a-button', {
                attrs: { type: 'link' },
                style: {
                  height: 0,
                },
                nativeOn: {
                  click: this.toApprove,
                },
              }, this.$t('scope.text_257')],
            ],
            interval: 1000 * 60 * 60 * 24,
          },
        },
      })
    },
    showSupperTips () {
      this.$store.dispatch('common/updateObject', {
        name: 'topAlert',
        data: {
          openCloudAccount: {
            messageOptions: [
              this.$t('scope.text_258'),
              ['a-button', {
                attrs: { type: 'link' },
                style: {
                  height: 0,
                },
                nativeOn: {
                  click: this.toCloudsupplier,
                },
              }, this.$t('scope.text_259')],
            ],
            interval: 1000 * 60 * 60 * 24,
          },
        },
      })
    },
    toOfficialWebsite () {
      window.open('https://www.yunion.cn/', '_blank')
    },
    toCost () {
      this.$router.push('/tenant-bill-overview')
    },
  },
}
</script>

<style lang="less" scoped>
  .certifiedStatus {
    position: fixed;
    top: 60px;
    right: 2px;
    left: 0;
  }
  .trigger {
    height: 100%;
    // padding: 0 20px;
    cursor: pointer;
    text-decoration: none;
  }
</style>
